export const NavDataConfig = [
    {
        number: '01',
        to: 'home',
        label: 'Home',
    },
    {
        number: '02',
        to: 'about',
        label: 'About',
    },
    
    {
        number: '03',
        to: 'srvices',
        label: 'Services',
    },
    {
        number: '04',
        to: 'whyChooseUs',
        label: 'WhyChooseUs',
    },
    {
        number: '05',
        to: 'projects',
        label: 'Projects',
    },
    {
        number: '06',
        to: 'contact',
        label: 'Contact',
    },
]